import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActionsBar = ({ selectedCount, onClearSelection, onBulkStatusUpdate, onBulkDelete }) => {
  const [bulkStatus, setBulkStatus] = React.useState('');

  const statusOptions = [
    { value: '', label: 'Select status...', disabled: true },
    { value: 'perfect', label: 'Perfect' },
    { value: 'damaged', label: 'Damaged' }
  ];

  const handleStatusUpdate = () => {
    if (bulkStatus) {
      onBulkStatusUpdate(bulkStatus);
      setBulkStatus('');
    }
  };

  if (selectedCount === 0) return null;

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 bg-primary text-primary-foreground rounded-lg elevation-3 z-40 transition-page">
      <div className="flex items-center gap-4 px-6 py-4">
        <div className="flex items-center gap-2">
          <Icon name="CheckSquare" size={20} />
          <span className="text-sm font-medium">{selectedCount} item{selectedCount !== 1 ? 's' : ''} selected</span>
        </div>

        <div className="h-6 w-px bg-primary-foreground/20" />

        <div className="flex items-center gap-2">
          <Select
            options={statusOptions}
            value={bulkStatus}
            onChange={setBulkStatus}
            className="w-40"
          />
          <Button
            variant="secondary"
            size="sm"
            onClick={handleStatusUpdate}
            disabled={!bulkStatus}
            iconName="RefreshCw"
            iconPosition="left"
            iconSize={16}
          >
            Update Status
          </Button>
        </div>

        <div className="h-6 w-px bg-primary-foreground/20" />

        <Button
          variant="destructive"
          size="sm"
          onClick={onBulkDelete}
          iconName="Trash2"
          iconPosition="left"
          iconSize={16}
        >
          Delete Selected
        </Button>

        <button
          onClick={onClearSelection}
          className="p-2 rounded-md hover:bg-primary-foreground/10 transition-smooth touch-target"
          aria-label="Clear selection"
        >
          <Icon name="X" size={20} />
        </button>
      </div>
    </div>
  );
};

export default BulkActionsBar;